import React from 'react';

const colorMap = {
  indigo: { bg: 'linear-gradient(135deg, #6366f1, #4f46e5)', light: '#eef2ff' },
  green: { bg: 'linear-gradient(135deg, #22c55e, #16a34a)', light: '#f0fdf4' },
  amber: { bg: 'linear-gradient(135deg, #f59e0b, #d97706)', light: '#fffbeb' },
  rose: { bg: 'linear-gradient(135deg, #f43f5e, #e11d48)', light: '#fff1f2' },
  blue: { bg: 'linear-gradient(135deg, #3b82f6, #2563eb)', light: '#eff6ff' },
};

function KpiCard({ title, value, suffix, icon, color = 'indigo', subtitle }) {
  const palette = colorMap[color] || colorMap.indigo;

  return (
    <div style={styles.card}>
      <div style={{ ...styles.iconBox, background: palette.bg }}>
        <span style={styles.icon}>{icon}</span>
      </div>
      <div style={styles.info}>
        <p style={styles.title}>{title}</p>
        <div style={styles.valueRow}>
          <span style={styles.value}>{value ?? '—'}</span>
          {suffix && <span style={styles.suffix}>{suffix}</span>}
        </div>
        {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: '#fff',
    borderRadius: 14,
    padding: '24px 22px',
    display: 'flex',
    alignItems: 'center',
    gap: 18,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    border: '1px solid #e5e7eb',
  },
  iconBox: {
    width: 54,
    height: 54,
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  icon: {
    fontSize: '1.6rem',
  },
  info: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  valueRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
    marginTop: 4,
  },
  value: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: '#1e1b4b',
    lineHeight: 1.2,
  },
  suffix: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#6366f1',
  },
  subtitle: {
    margin: '4px 0 0',
    fontSize: '0.78rem',
    color: '#9ca3af',
  },
};

export default KpiCard;
